function getSEOPanels() {
  return import('advancedSeoClient').then((advancedSeoClient) => {
    return { tabs: advancedSeoClient.NEW_ORDER_SEO_TABS };
  });
}

export { getSEOPanels };
